import VisualizarClienteModal from './VisualizarClienteModal';

export default VisualizarClienteModal;
